/* eslint-disable react/display-name */
/* eslint-disable react-hooks/exhaustive-deps */
//external imports
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MaterialTable from '../../../components/v4/MaterialTable';
import useAddress from '../../../hooks/useAddress';
import { useQuery } from '@tanstack/react-query';

import { axios } from '../../../services/axios';
import { Button } from 'react-bootstrap';
import { addressColumns } from './consts';
import { ChakraProvider, Box, Flex } from '@chakra-ui/react';
import chakratheme from '../../../chakratheme';

import AddressesCreate from './AddressesCreate';
import AddressesEdit from './AddressesEdit';

import MaterialEditIcon from '@material-ui/icons/Edit';
import AddRoundedIcon from '@material-ui/icons/AddRounded';

import walkthroughIds from '../walkthroughIds';
import { loadingColumnsConstructor } from 'components/tables/ReduxTable';
import { nullError } from 'components/error';
import { Error } from 'components/index';
import { refreshTable } from 'pages/tpm/AssociatedAccounts/helper';
import { useNavigate } from 'react-router-dom';

const { addresses } = walkthroughIds;

const Edit = React.forwardRef((props, ref) => (
    <MaterialEditIcon
        {...props}
        ref={ref}
        data-walkthroughid={addresses.ufEditButton}
    />
));

function AddressesHeader({ setAddressAction }) {
    return (
        <div>
            <Button
                className="btn btn-primary btn-sm"
                style={{ marginBottom: '5%', appearance: 'none' }}
                onClick={() => setAddressAction('Create')}
                data-walkthroughid={addresses.ufAddButton}>
                {' '}
                <AddRoundedIcon
                    fontSize="small"
                    style={{ marginBottom: '2%' }}
                />{' '}
                Address
            </Button>
        </div>
    );
}
function CSVHeader() {
    const navigate = useNavigate();
    return (
        <div>
            <Button
                className="btn btn-primary btn-sm"
                style={{ marginBottom: '5%', appearance: 'none' }}
                onClick={() => navigate('/addresses/csv-address')}
                data-walkthroughid={addresses.ufAddButton}>
                {' '}
               
                CSV Upload
            </Button>
        </div>
    );
}

const Addresses = () => {
    const [selectedRowData, setSelectedRowData] = useState();
    const [addressAction, setAddressAction] = useState('Get');
    const [data, setData] = useState([]);
    const { currentCompany } = useSelector((state) => {
        return { ...state.navigationLists };
    });
    const dispatch = useDispatch();
    const tableRef = useRef(null);

    const { concatAddressFields } = useAddress();

    function editAddressItem(rowData) {
        setSelectedRowData(rowData);
        setAddressAction('Edit');
    }

    const { refetch, isRefetching, status } = useQuery({
        queryKey: ['addresses', currentCompany],
        queryFn: async () => {
            const data = await axios.get(`/Addresses/${currentCompany}`);
            return data.data;
        },
        onSuccess: (data) => {
            const addressess = data.map((address) => {
                return {
                    address: concatAddressFields(address),
                    ...address,
                };
            });
            setData(addressess);
        },
        refetchOnWindowFocus: false,
    });

    const refreshFn = () => {
        dispatch({
            type: 'CHANGE_TABLE_FILTERING',
        });
        tableRef.current &&
            tableRef.current.dataManager.columns.forEach((item) => {
                tableRef.current.onFilterChange(item.tableData.id, '');
            });
        refetch();
    };

    useEffect(() => {
        if (currentCompany) {
            refreshFn();
        }
    }, [addressAction, currentCompany, refreshTable]); // will trigger a refresh, after creating or saving an address

    const loadingColumns = useMemo(
        () => loadingColumnsConstructor(addressColumns),
        [addressColumns],
    );
    const dummyTable = [];
    const dummyTableLength = 12;

    for (let i = 0; i < dummyTableLength; i++) {
        const obj = {
            title: `Title ${i + 1}`,
            field: `Field ${i + 1}`,
        };
        dummyTable.push(obj);
    }

    if (!currentCompany) {
        return (
            <>
                <Error error={nullError} />
            </>
        );
    }

    const titleName = 'Addresses';
    const componentLoadingState = status === 'loading' || isRefetching;
    const renderedColumns = componentLoadingState
        ? loadingColumns
        : addressColumns;
    const renderedTableData = componentLoadingState ? dummyTable : data;

    return (
        <ChakraProvider theme={chakratheme} resetCSS={true}>
            {addressAction === 'Get' && (
                <>
                    <h1 className="mb-2 text-[2.5rem] font-medium">
                        {titleName}
                    </h1>
                    <MaterialTable
                        refreshFn={refreshFn}
                        title={
                            <Flex gap='4'>
                            <AddressesHeader
                                setAddressAction={setAddressAction}
                            />
                            <CSVHeader
                            />
                            </Flex>
                        }
                        titleName={titleName}
                        tableRef={tableRef}
                        refreshTable={refreshFn}
                        columns={renderedColumns}
                        data={renderedTableData}
                        actions={[
                            {
                                icon: Edit,
                                tooltip: 'Edit',
                                isFreeAction: false,
                                onClick: (e, rowData) => {
                                    editAddressItem(rowData);
                                },
                            },
                        ]}
                    />
                </>
            )}
            <Box sx={{ maxW: '1000px', margin: '0 auto' }}>
                {addressAction === 'Create' && (
                    <AddressesCreate setAddressAction={setAddressAction} />
                )}
                {addressAction === 'Edit' && (
                    <AddressesEdit
                        setAddressAction={setAddressAction}
                        rowData={selectedRowData}
                    />
                )}
            </Box>
        </ChakraProvider>
    );
};

export default Addresses;
